// extracted by mini-css-extract-plugin
module.exports = {"input":"IndustryForm_input__1Nu7n","last":"IndustryForm_last__1mFBf","form":"IndustryForm_form__1t83f"};